<template>
  <main>
    <div class="container">
      <!-- 新聞標題 -->
      <div class="news_title">
        <h3>{{ $t("news.newsNotice") }}</h3>
        <hr class="green" />
        <h5>News</h5>

        <p>
          <router-link :to="{ name: 'homeH5' }">{{ $t("news.home") }}</router-link
          >> <a :to="{ name: 'newsH5' }">{{ $t("news.news") }}</a
          >>
          <a class="active">{{ $t("news.body") }}</a>
        </p>
      </div>
      <!-- 新聞正文 -->
      <div class="news_body">
        <div class="news_info">
          <h3 v-html="news_data.title"></h3>
          <template v-if="$region == 'jp'">
            <p class="jp">
              <span
                v-html="
                  $t('news.time') + '：' + getDateString(news_data.publish_time)
                "
              ></span>
            </p>
          </template>
          <template v-else>
            <p>
              <span
                v-html="
                  $t('news.news') + '：' + getDateString(news_data.publish_time)
                "
              ></span>
              <span v-html="$t('news.author') + '：' + news_data.author"></span>
              <span v-html="$t('news.origin') + '：' + news_data.source"></span>
            </p>
          </template>
        </div>
        <hr />
        <div class="news_content" v-html="news_data.content"></div>
      </div>

      <!-- 返回鏈接 -->
      <div class="back_list">
        <router-link :to="{ name: 'newsH5' }" ga-data="401001">
          <img src="../../../assets/images/news/arrow_left_circle.svg" alt />
          {{ $t("news.backList") }}
        </router-link>
      </div>

      <!-- 回到顶部 -->
      <a href="#" class="toTop" v-show="totop"></a>
    </div>
  </main>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
    },
  },
  name: "newsDetailH5",
  data() {
    return {
      news_data: {
        news_id: 0,
        type: 1,
        title: "",
        publish_time: "",
        author: "",
        source: "",
        content: "",
      },
      totop: false,
    };
  },
  methods: {
    getNewsType(id) {
      switch (id) {
        case 1:
          return this.$t("news.notice");
        //   break;
        case 2:
          return this.$t("news.preserve");
        //   break;
        case 3:
          return this.$t("news.news");
        //   break;
        case 4:
          return this.$t("news.active");
        //   break;
        case 5:
          return this.$t("news.declare");
        //   break;
        default:
          return id;
        //   break;
      }
    },
    handleScroll() {
      if (
        self.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      ) {
        this.totop = true;
      } else {
        this.totop = false;
      }
    },
    getDateString(t) {
      if (!t) {
        return 0;
      }
      let ts = new Date(t.replace(/-/g, '/'));
      return ts.toLocaleDateString();
    },
  },
  mounted() {
    // 请求置顶新闻
    this.$apis.home.previewNewsDetail(this.id).then((data) => {
      let res = data.data;
      if (res.code == 0) {
        this.news_data = res.data;
      } else {
        // console.error(res.message);
      }
    });

    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
// 关于小萌，联系我们，会员规章
body,
div,
p,
h3,
h4,
h5,
span {
  margin: 0;
  padding: 0;
}
a {
  color: inherit;
  text-decoration: none;
}
.container {
  width: 100%;
  margin: 0 auto;
  padding-top: 0.7rem;
  min-height: calc(100vh - 2.42rem);
  display: flex;
  flex-direction: column;
  .news_title {
    text-align: center;
    border-bottom: 0.01rem solid #eeeeee;
    display: flex;
    flex-direction: column;
    h3 {
      font-size: 0.16rem;
      color: #444444;
    }
    hr.green {
      width: 0.24rem;
      height: 0.02rem;
      border: 0;
      margin: 0.03rem auto;
      background: #50bbe5;
      border-radius: 0.02rem;
    }
    h5 {
      font-size: 0.1rem;
      color: #cccccc;
      margin-bottom: 0.2rem;
    }
    p {
      text-align: left;
      font-size: 0.17rem;
      padding-left: 0.26rem;
    }
  }
  .news_body {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    .news_info {
      text-align: center;
      h3 {
        font-weight: bold;
        margin: 0.26rem auto 0.1rem auto;
        color: #444444;
        font-size: 0.16rem;
      }
      p {
        width: 100%;
        display: flex;
        margin: 0 auto;
        color: #ccc;
        justify-content: space-between;
        &.jp {
          justify-content: center;
        }
        span {
          flex-grow: 0;
          font-size: 0.12rem;
        }
      }
    }
    hr {
      border: 0;
      height: 0.01rem;
      background: #eeeeee;
      margin: 0.26rem auto 0.26rem auto;
      width: 70%;
    }
  }
  .news_content {
    min-height: 4rem;
    box-sizing: border-box;
    padding: 0 0.42rem;
    width: 100%;
    height: 100%;
    font-size: 0.14rem;
    line-height: 0.28rem;
  }
  .back_list {
    border-top: 0.01rem solid #eeeeee;
    text-align: center;
    padding: 0.2rem;
    display: flex;
    justify-content: center;
    flex: 1;
    a {
      display: inline-block;
      width: 1.7rem;
      height: 0.4rem;
      border: 0.01rem solid #50bbe5;
      border-radius: 0.2rem;
      font-size: 0.14rem;
      color: #333333;
      line-height: 0.4rem;
      img {
        width: 0.12rem;
      }
    }
  }

  .toTop {
    display: block;
    position: fixed;
    width: 0.42rem;
    height: 0.38rem;
    right: 0.2rem;
    bottom: 0.6rem;
    background: url(../../../assets/images/news/totop_nor.svg) center center
      no-repeat;
    background-size: contain;
  }
}
::v-deep img{
  width: 100%;
}
</style>
